import { env } from '@funny/env';
var OutsideBar = /** @class */ (function () {
    function OutsideBar(options) {
        this.config = {
            openApp: function () {
                throw new Error('the method must be set');
            },
        };
        // 如果不是在站外的话，不处理outside-bar
        if (!env.browser.isOutChangba) {
            return;
        }
        this.insertCss();
        this.insertHtml();
        this.moveBody();
        Object.assign(this.config, options || {});
    }
    /**
     * 因为插入了站外分享栏，元素需要下移动
     */
    OutsideBar.prototype.moveBody = function () {
        var bodyEl = document.querySelector('body');
        var bodyStyle = getComputedStyle(bodyEl, null);
        // 向上移动，以适应out-site-bar的插入
        bodyEl.style.paddingTop = '1.6rem';
        bodyEl.style.backgroundPositionY = '1.6rem';
        bodyEl.style.height = document.documentElement.clientHeight - (Number.parseFloat(bodyStyle.marginTop) || 0) + 'px';
    };
    OutsideBar.prototype.openApp = function () {
        var _a, _b;
        var targetUrl = this.config.targetUrl || window.location.href;
        var downloadUrl = 'https://itunes.apple.com/cn/app/id509885060?ls=1&amp;mt=8';
        if (env.browser.isQQorWeChat) {
            downloadUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.changba&ckey=CK1359485898763';
        }
        else if (env.browser.isAndroid) {
            downloadUrl = 'http://changba.com/redirect/latest_app.php';
        }
        if (targetUrl.indexOf('?') > 0) {
            targetUrl =
                targetUrl.replace('curuserid=', 'share_source_userid=').replace('token=', 'outtoken=') + '&refsrc=openApp';
        }
        else {
            targetUrl =
                targetUrl.replace('curuserid=', 'share_source_userid=').replace('token=', 'outtoken=') + '?refsrc=openApp';
        }
        // 让外界传入，组件内不内置
        (_b = (_a = this.config).openApp) === null || _b === void 0 ? void 0 : _b.call(_a, {
            targetUrl: targetUrl,
            downloadUrl: downloadUrl,
        });
    };
    /**
     * 插入站外分享栏的样式
     * @returns
     */
    OutsideBar.prototype.insertCss = function () {
        if (document.querySelector('#outside-share-bar-style')) {
            return;
        }
        var cssNode = document.createElement('style');
        cssNode.id = 'outside-share-bar-style';
        var cssRules = "\n    .outside-share-bar {\n      color: #fff;\n    }\n\n    .outside-share-bar__main {\n      display: flex;\n      align-content: stretch;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      background: rgba(22, 22, 34, 0.9);\n      padding: 0.26667rem 0.26667rem 0.26667rem 0.42667rem;\n      height: 1.6rem;\n      position: fixed;\n      top: 0;\n      z-index: 99999;\n    }\n\n    .outside-share-bar__logo-container {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-content: flex-start;\n      align-items: center;\n    }\n\n    .outside-share-bar__logo-icon {\n      width: 1.06667rem;\n      height: 1.06667rem;\n      flex-shrink: 0;\n    }\n\n    .outside-share-bar__logo-icon img {\n      display: block;\n      width: 100%;\n      height: 100%;\n      border-radius: 0.21333rem;\n    }\n\n    .outside-share-bar__des-container {\n      margin-left: 0.21333rem;\n    }\n\n    .outside-share-bar__logo-title {\n      font-size: 0.37333rem;\n      line-height: 1;\n      margin: 0;\n    }\n\n    .outside-share-bar__logo-des {\n      font-size: 0.32rem;\n      margin: 0.10667rem 0 0 0;\n      color: rgba(255, 255, 255, 0.6);\n      line-height: 1;\n    }\n\n    .outside-share-bar__clip-btn {\n      display: block;\n      height: 0.85333rem;\n      border: 0;\n      background-image: linear-gradient(90deg, #f22 0%, #ff0040 100%);\n      background-color: transparent;\n      border-radius: 0.45333rem;\n      font-size: 0.37333rem;\n      color: #fff;\n      padding-left: 0.37333rem;\n      padding-right: 0.37333rem;\n    }\n\n    .outside-share-bar__clip-btn:focus,\n    .outside-share-bar__clip-btn:active {\n      border: 0;\n      outline: 0;\n    }\n    ";
        cssNode.innerHTML = cssRules;
        document.head.appendChild(cssNode);
    };
    /**
     * 插入站外分享栏的html
     * @returns
     */
    OutsideBar.prototype.insertHtml = function () {
        var _this = this;
        if (document.querySelector('#outside-share-bar')) {
            return;
        }
        var barRoot = document.createElement('div');
        barRoot.classList.add('outside-share-bar');
        barRoot.id = 'outside-share-bar';
        var htmlSnippet = "<div class=\"outside-share-bar__main\">\n                          <div class=\"outside-share-bar__logo-container\">\n                            <div class=\"outside-share-bar__logo-icon\">\n                              <img src=\"https://res.cdn.changbaimg.com/-/cfb16c1eb27acd2b/logo.png\" alt=\"\u5531\u5427LOGO\" />\n                            </div>\n                            <div class=\"outside-share-bar__des-container\">\n                              <div class=\"outside-share-bar__logo-title\">\u5531\u5427</div>\n                              <div class=\"outside-share-bar__logo-des\">\u65F6\u5C1A\u7684\u4EBA\u90FD\u5728\u7528\u7684\u624B\u673AKTV</div>\n                            </div>\n                          </div>\n                          <div class=\"outside-share-bar__share-action\">\n                            <button type=\"button\" class=\"outside-share-bar__clip-btn\">\u7ACB\u5373\u6253\u5F00</button>\n                          </div>\n                        </div>";
        barRoot.innerHTML = htmlSnippet;
        var btn = barRoot.querySelector('.outside-share-bar__clip-btn');
        btn &&
            btn.addEventListener('click', function () {
                _this.openApp();
            });
        document.body.appendChild(barRoot);
    };
    return OutsideBar;
}());
export { OutsideBar };
